import './Rooms.css';

function Rooms() {
  const roomImages = [
    process.env.PUBLIC_URL + "/images/room1.jpg",
    process.env.PUBLIC_URL + "/images/room2.jpg",
    process.env.PUBLIC_URL + "/images/room3.jpg",

  ];

  return (
    <div className="rooms-page">
      <h2>Our Rooms</h2>
      <p>Welcome Inn offers a variety of clean and comfortable room types designed for a relaxing stay</p>
      <p>All rooms come with free Wi-Fi, a TV, a mini-fridge, coffee machine, microwave, and daily housekeeping.</p>

      <div className="room-gallery">
        {roomImages.map((src, index) => (
          <img key={index} src={src} alt={`Room ${index + 1}`} className="room-image" />
        ))}
      </div>
    </div>
  );
}

export default Rooms;
